import { vars } from "@/shared/lib/theme.css";
import { Typography } from "@/shared/ui";
import { MouseEventHandler } from "react";
import { IconType } from "react-icons/lib";

import { motion } from "framer-motion";
import { SidebarButtonVarients, sidebarButton } from "./index.css";

type SidebarButtonProps = {
	icon: IconType;
	title: string;
	active: boolean;
	isUnclickable: boolean;
	onClick?: MouseEventHandler<HTMLDivElement>;
} & SidebarButtonVarients;

function SidebarButton({ icon, title, isUnclickable = false, onClick, active }: SidebarButtonProps) {
	return (
		<motion.div
			initial={{ opacity: 0.1 }}
			animate={{ opacity: 1 }}
			whileTap={{ opacity: 0.8, scale: 0.95 }}
			transition={{ duration: 0.2 }}
			className={sidebarButton({ active, isUnclickable })}
			onClick={onClick}
		>
			{icon({ size: isUnclickable ? 20 : 16, fill: active ? vars.color.white : vars.color.black })}
			<Typography
				fontWeight={isUnclickable ? "bold" : "normal"}
				size={isUnclickable ? vars.size[20] : vars.size[16]}
				style={{
					color: active ? vars.color.white : vars.color.black
				}}
			>
				{title}
			</Typography>
		</motion.div>
	);
}

export default SidebarButton;